module.exports = __webpack_public_path__ + "static/img/2.4b6f9d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/6/eng/2.png
// module id = msoi
// module chunks = 0